import validate from "/home/runner/work/parmazip-patient/parmazip-patient/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.14.9_encoding_586448ee85668d727b680e81591941e3/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/parmazip-patient/parmazip-patient/src/middleware/auth.global.js";
import manifest_45route_45rule from "/home/runner/work/parmazip-patient/parmazip-patient/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.14.9_encoding_586448ee85668d727b680e81591941e3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "exclude-route": () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/middleware/exclude-route.js")
}